<template>
  <HeaderApp />
  <div
    :class="
      '  mx-2 mt-14 p-3 bg-slate-100 dark:bg-bgFullDark rounded-2xl ' +
      ($store.getters['isRtl']
        ? $store.state.navbar.isSidebarCollapsed
          ? ' md:mr-20 '
          : ' md:mr-60 '
        : $store.state.navbar.isSidebarCollapsed
        ? ' md:ml-20  '
        : ' md:ml-60  ')
    "
  >
    <div class="flex mb-4">
      <p class="font-semibold text-xl text-textBlack dark:text-textWhite mx-3">
        {{ $t("add_debt") }}
      </p>
    </div>

    <div class="m-2 p-3 bg-white dark:bg-bgMeduimDark rounded-2xl">
      <div class="">
        <form @submit="addSaleItem">
          <div class="grid gap-x-6 mb-6 md:grid-cols-2">
            <BaseInput
              v-model="deb_amount"
              :label="$t('debt_amount')"
              :placeholder="$t('debt_amount')"
              :rules="rules"
              type="number"
              :isError="
                checkRulesIsError(deb_amount, 'add', this.rules).isError
              "
              :errorMsg="
                checkRulesIsError(deb_amount, 'add', this.rules).errorMsg
              "
            />
            <DropdownInput
              v-model="cur_id"
              :label="$t('currency_type')"
              :items="convertToListIdValue"
              :placeholder="$t('currency_type')"
              :rules="rules_dropdown"
              :isError="
                checkRulesIsError(cur_id, 'add', this.rules_dropdown).isError
              "
              :errorMsg="
                checkRulesIsError(cur_id, 'add', this.rules_dropdown).errorMsg
              "
            /><DropdownInput
              v-model="deb_type"
              :label="$t('debt_type')"
              :placeholder="$t('debt_type')"
              :rules="rules_dropdown"
              :items="debtTypes"
              :isError="
                checkRulesIsError(deb_type, 'add', this.rules_dropdown).isError
              "
              :errorMsg="
                checkRulesIsError(deb_type, 'add', this.rules_dropdown).errorMsg
              "
            /><DropdownInput
              v-model="bo_id"
              :label="$t('box_debt')"
              :placeholder="$t('choose_box_if_debt_is_in_or_out_from_box')"
              :rules="no_rule"
              :items="convertToListIdValueBoxes"
              :isError="checkRulesIsError(bo_id, 'add', this.no_rule).isError"
              :errorMsg="checkRulesIsError(bo_id, 'add', this.no_rule).errorMsg"
              linkDrop="/all-box"
            />
            <div class="mb-6" v-if="su_id == '' || su_id == null">
              <div class="flex">
                <div class="w-full">
                  <DropdownInput
                    v-model="cu_id"
                    :label="$t('customer')"
                    :placeholder="
                      $t('choose_customer_if_debt_is_in_or_out_from_customer')
                    "
                    :items="convertToListIdValueCustomers"
                    :rules="rules_dropdown"
                    :call="getCustomerDebt"
                    :isError="
                      checkRulesIsError(cu_id, 'add', this.rules_dropdown)
                        .isError
                    "
                    :errorMsg="
                      checkRulesIsError(cu_id, 'add', this.rules_dropdown)
                        .errorMsg
                    "
                  />
                </div>
                <div class="w-2"></div>
                <a
                  class="w-2/12 lg:w-1/12 text-white text-2xl my-9 bg-primaryColor p-1 rounded-lg hover:shadow-md text-center"
                  target="_blank"
                  href="/customer"
                >
                  +
                </a>
              </div>
              <div
                v-show="isShowDebts && cu_id"
                class="mt-2 rounded-lg border border-amber-200 dark:border-amber-700 bg-amber-50 dark:bg-amber-900/20 px-3 py-2 text-xs"
              >
                <div class="flex justify-between gap-2">
                  <span>{{ $t("total_debt_dinar") }}</span>
                  <b :class="debtAmountClass(beforeDebtIQD)">{{
                    formatNumber(beforeDebtIQD)
                  }}</b>
                </div>
                <div class="flex justify-between gap-2 mt-1">
                  <span>{{ $t("total_debt_dollar") }}</span>
                  <b :class="debtAmountClass(beforeDebtUSD)">{{
                    formatNumber(beforeDebtUSD)
                  }}</b>
                </div>
              </div>
            </div>
            <div class="mb-6" v-if="cu_id == '' || cu_id == null">
              <div class="flex">
                <div class="w-full">
                  <DropdownInput
                    v-model="su_id"
                    :label="$t('suplier')"
                    :placeholder="
                      $t('chhose_suplier_if_debt_is_in_or_out_from_suplier')
                    "
                    :items="convertToListIdValueSupliers"
                    :rules="rules_dropdown"
                    :call="getSuplierDebt"
                    :isError="
                      checkRulesIsError(su_id, 'add', this.rules_dropdown)
                        .isError
                    "
                    :errorMsg="
                      checkRulesIsError(su_id, 'add', this.rules_dropdown)
                        .errorMsg
                    "
                  />
                </div>
                <div class="w-2"></div>
                <a
                  class="w-2/12 lg:w-1/12 text-white text-2xl my-9 bg-primaryColor p-1 rounded-lg hover:shadow-md text-center"
                  target="_blank"
                  href="/suplier"
                >
                  +
                </a>
              </div>
              <div
                v-show="isShowDebts && su_id"
                class="mt-2 rounded-lg border border-amber-200 dark:border-amber-700 bg-amber-50 dark:bg-amber-900/20 px-3 py-2 text-xs"
              >
                <div class="flex justify-between gap-2">
                  <span>{{ $t("total_debt_dinar") }}</span>
                  <b :class="debtAmountClass(beforeDebtIQD)">{{
                    formatNumber(beforeDebtIQD)
                  }}</b>
                </div>
                <div class="flex justify-between gap-2 mt-1">
                  <span>{{ $t("total_debt_dollar") }}</span>
                  <b :class="debtAmountClass(beforeDebtUSD)">{{
                    formatNumber(beforeDebtUSD)
                  }}</b>
                </div>
              </div>
            </div>

            <BaseInput
              v-model="deb_wasl"
              :label="$t('debt_invoice_number')"
              :placeholder="$t('debt_invoice_number')"
              :rules="no_rule"
              :isError="
                checkRulesIsError(deb_wasl, 'add', this.no_rule).isError
              "
              :errorMsg="
                checkRulesIsError(deb_wasl, 'add', this.no_rule).errorMsg
              "
            />
            <div v-if="isDiscountAllowed">
              <BaseInput
                v-model="deb_discount"
                :label="$t('debt_discount')"
                :placeholder="$t('debt_discount')"
                :rules="no_rule"
                type="number"
                :isError="
                  checkRulesIsError(deb_discount, 'add', this.no_rule).isError
                "
                :errorMsg="
                  checkRulesIsError(deb_discount, 'add', this.no_rule).errorMsg
                "
              />
              <p
                v-if="parseFloat(deb_discount) > 0"
                class="text-xs mt-1 text-gray-600 dark:text-gray-300"
              >
                <span class="font-bold">{{ $t("total_settled") }}: </span>
                <span>{{
                  formatNumber(
                    (parseFloat(deb_amount) || 0) +
                      (parseFloat(deb_discount) || 0)
                  )
                }}</span>
              </p>
            </div>
            <BaseInput
              v-if="isDiscountAllowed"
              v-model="deb_discount_note"
              :label="$t('debt_discount_note')"
              :placeholder="$t('debt_discount_note')"
              :rules="no_rule"
              :isError="
                checkRulesIsError(deb_discount_note, 'add', this.no_rule).isError
              "
              :errorMsg="
                checkRulesIsError(deb_discount_note, 'add', this.no_rule).errorMsg
              "
            />
            <BaseInput
              v-model="created_at"
              type="date"
              :label="$t('debt_date')"
              :placeholder="$t('debt_date')"
              :rules="no_rule"
              :isError="
                checkRulesIsError(created_at, 'add', this.no_rule).isError
              "
              :errorMsg="
                checkRulesIsError(created_at, 'add', this.no_rule).errorMsg
              "
            />
            <BaseInput
              v-model="deb_return_date"
              type="date"
              :label="$t('debt_return_date')"
              :placeholder="$t('debt_return_date')"
              :rules="no_rule"
              :isError="
                checkRulesIsError(deb_return_date, 'add', this.no_rule).isError
              "
              :errorMsg="
                checkRulesIsError(deb_return_date, 'add', this.no_rule).errorMsg
              "
            />
            <div>
              <FileInput
                v-model="deb_image"
                :label="$t('debt_photo')"
                :placeholder="$t('choose_debt_photo')"
                accept="image/*"
                :show-preview="true"
                @change="onChange"
              />
            </div>
            <TextAreaInput
              v-model="deb_note"
              :label="$t('note')"
              :placeholder="$t('note')"
              :rules="no_rule"
              :isError="
                checkRulesIsError(deb_note, 'add', this.no_rule).isError
              "
              :errorMsg="
                checkRulesIsError(deb_note, 'add', this.no_rule).errorMsg
              "
            />
          </div>
          <div>
            <div class="flex mx-4 mt-4">
              <div class="flex items-center ml-4">
                <input
                  id="inline-radio11"
                  type="radio"
                  value="1"
                  checked="true"
                  v-model="isPrint"
                  name="inline-radio-group1"
                  class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  @change="printStatus"
                />
                <label
                  for="inline-radio"
                  class="mr-2 text-base font-medium text-gray-900 dark:text-gray-300"
                  >{{ $t("print") }}</label
                >
              </div>
              <div class="flex items-center ml-4">
                <input
                  id="inline-3-radio11"
                  type="radio"
                  value="2"
                  v-model="isPrint"
                  name="inline-radio-group1"
                  class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  @change="printStatus"
                />
                <label
                  for="inline-radio"
                  class="mr-2 text-base font-medium text-gray-900 dark:text-gray-300"
                  >{{ $t("no_print") }}</label
                >
              </div>
            </div>
          </div>
          <br />
          <ButtonInput
            type="button"
            @click="addSaleItem"
            :label="$t('add')"
            :isLoading="isBtnLoading"
          />
        </form>
      </div>
    </div>
  </div>

  <ResultDialog ref="ResultDialog"></ResultDialog>
</template>
<script>
//import hearder-app
import HeaderApp from "../../components/Navbar/header-app.vue";
import BaseInput from "../../components/Inputs/BaseInput.vue";
import TextAreaInput from "../../components/Inputs/TextAreaInput.vue";
import ButtonInput from "../../components/Inputs/ButtonInput.vue";
import { formatDate, formatNumber } from "../../utils/functions";
import { CURRENCYS } from "../../constants/config";
import ResultDialog from "../../components/Modals/ResultDialog.vue";
import DropdownInput from "../../components/Inputs/DropdownInput.vue";
import FileInput from "../../components/Inputs/FileInput.vue";
export default {
  name: "ADD_SALE_TYPE",
  components: {
    HeaderApp,
    BaseInput,
    ButtonInput,
    ResultDialog,
    TextAreaInput,
    DropdownInput,
    FileInput,
  },
  data() {
    return {
      rules: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_fill_this_field");
        },
      ],
      no_rule: [],
      isSubmited: false,
      currencys: CURRENCYS,
      rules_dropdown: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_choose_an_option");
        },
      ],
      cur_id: 2,
      su_id: "",
      bo_id: "",
      cu_id: "",
      deb_note: "",
      deb_wasl: "",
      isPrint: "2",
      deb_amount: "",
      deb_discount: "",
      deb_discount_note: "",
      created_at: "",
      deb_return_date: "",
      deb_type: "",
      deb_image: "",
      beforeDebtIQD: 0,
      beforeDebtUSD: 0,
      isShowDebts: false,

      debtTypes: [
        {
          id: "1",
          value: this.$t("lend"),
        },
        {
          id: "0",
          value: this.$t("borrow"),
        },
      ],
    };
  },
  created() {
    this.$store.dispatch("all_box/getBoxes");

    this.$store.dispatch("debt_category/getExpenseCategory");
    this.$store.dispatch("customer/getCustomers");
    this.$store.dispatch("suplier/getSupliers");
    this.$store.dispatch("navbar/getItems");
  },

  computed: {
    isDark() {
      return this.$store.state.theme == "dark";
    },
    isBtnLoading() {
      return this.$store.state.add_debt.isBtnLoading;
    },
    // Discount only on settlement: customer pays (type 0 + customer) or we pay supplier (type 1 + supplier).
    isDiscountAllowed() {
      const t = this.deb_type;
      if (t === "0" || t === 0) return !!this.cu_id;
      if (t === "1" || t === 1) return !!this.su_id;
      return false;
    },
    convertToListIdValue() {
      var list = [];
      for (const item of this.currencys) {
        list.push({
          id: item.cur_id,
          value: this.$t(item.cur_name),
        });
      }

      return list;
    },
    convertToListIdValueBoxes() {
      var boxes = this.$store.state.all_box.boxes;
      var list = [];
      for (const item of boxes) {
        list.push({
          id: item.bo_id,
          value: item.bo_name,
        });
      }

      return list;
    },
    convertToListIdValueCustomers() {
      var customers = this.$store.state.customer.customers;
      var list = [];
      for (const item of customers) {
        list.push({
          id: item.cu_id,
          value: item.cu_name,
        });
      }

      return list;
    },
    convertToListIdValueSupliers() {
      var supliers = this.$store.state.suplier.supliers;
      var list = [];
      for (const item of supliers) {
        list.push({
          id: item.su_id,
          value: item.su_name,
        });
      }

      return list;
    },
  },

  methods: {
    onChange(e) {
      this.deb_image = e.target.files[0];
      e.target.value = "";
    },
    formatDate(date) {
      return formatDate(date);
    },
    formatNumber(n) {
      return formatNumber(n);
    },
    // Same as customer/supplier lists: positive = they owe you (red), else you owe them (green)
    debtAmountClass(amount) {
      return Number(amount) > 0 ? "text-red-500" : "text-green-500";
    },
    resetDebtBalance() {
      this.beforeDebtIQD = 0;
      this.beforeDebtUSD = 0;
      this.isShowDebts = false;
    },
    async getCustomerDebt() {
      if (!this.cu_id) {
        this.resetDebtBalance();
        return;
      }
      this.isShowDebts = false;
      try {
        const res = await this.$store.dispatch("customer/getCurrentDebt", {
          cu_id: this.cu_id,
          created_at: this.created_at || new Date().toISOString(),
        });
        if (res && res.balance_before_date) {
          this.beforeDebtIQD = res.balance_before_date.IQD || 0;
          this.beforeDebtUSD = res.balance_before_date.USD || 0;
        } else {
          this.beforeDebtIQD = 0;
          this.beforeDebtUSD = 0;
        }
        this.isShowDebts = true;
      } catch (error) {
        console.error("Error fetching customer debt:", error);
        this.beforeDebtIQD = 0;
        this.beforeDebtUSD = 0;
        this.isShowDebts = true;
      }
    },
    async getSuplierDebt() {
      if (!this.su_id) {
        this.resetDebtBalance();
        return;
      }
      this.isShowDebts = false;
      try {
        const res = await this.$store.dispatch("suplier/getCurrentDebt", {
          su_id: this.su_id,
          created_at: this.created_at || new Date().toISOString(),
        });
        if (res && res.balance_before_date) {
          this.beforeDebtIQD = res.balance_before_date.IQD || 0;
          this.beforeDebtUSD = res.balance_before_date.USD || 0;
        } else {
          this.beforeDebtIQD = 0;
          this.beforeDebtUSD = 0;
        }
        this.isShowDebts = true;
      } catch (error) {
        console.error("Error fetching supplier debt:", error);
        this.beforeDebtIQD = 0;
        this.beforeDebtUSD = 0;
        this.isShowDebts = true;
      }
    },

    async addSaleItem() {
      //check form validation
      if (this.$store.state.add_debt.isBtnLoading) return;

      this.isSubmited = true;
      if (
        this.checkRulesIsError(this.cur_id, "add", this.rules_dropdown)
          .isError ||
        this.checkRulesIsError(this.deb_type, "add", this.rules_dropdown)
          .isError ||
        this.checkRulesIsError(this.deb_amount, "add", this.rules).isError
      ) {
        return;
      }
      //at least 1 of customer or suplier must be selected
      if (!this.checkIsEmpty(this.cu_id) && !this.checkIsEmpty(this.su_id)) {
        this.$refs.ResultDialog.show({
          message: this.$t("you_must_choose_only_customer_or_suplier"),
          okButton: this.$t("ok"),
          isSuccess: false,
        });
        return;
      }
      if (this.checkIsEmpty(this.cu_id) && this.checkIsEmpty(this.su_id)) {
        this.$refs.ResultDialog.show({
          message: this.$t("you_must_choose_at_least_one_customer_or_suplier"),
          okButton: this.$t("ok"),
          isSuccess: false,
        });
        return;
      }

      //
      if (this.cu_id == null) {
        this.cu_id = "";
      }
      if (this.su_id == null) {
        this.su_id = "";
      }
      const discountValue = parseFloat(this.deb_discount) || 0;
      if (discountValue > 0 && (this.bo_id == "" || this.bo_id == null)) {
        this.$refs.ResultDialog.show({
          message: this.$t("discount_requires_box"),
          okButton: this.$t("ok"),
          isSuccess: false,
        });
        return;
      }
      this.$store.state.add_debt.isBtnLoading = true;
      var res = await this.$store.dispatch("add_debt/addNewItem", {
        cur_id: this.cur_id,
        deb_type: this.deb_type,
        bo_id: this.bo_id,
        cu_id: this.cu_id,
        deb_note: this.deb_note,
        deb_wasl: this.deb_wasl,
        deb_amount: this.deb_amount,
        deb_discount: this.isDiscountAllowed ? discountValue : 0,
        deb_discount_note: this.isDiscountAllowed
          ? this.deb_discount_note
          : "",
        deb_main_currency_price: this.$store.state.navbar.dp_price,
        created_at: this.created_at,
        deb_return_date: this.deb_return_date,
        su_id: this.su_id,
        deb_image: this.deb_image,
      });

      if (res.status == 200) {
        var debt_id = res.data.debt_id;
        this.deb_amount = "";
        this.deb_discount = "";
        this.deb_discount_note = "";
        this.deb_note = "";
        this.deb_wasl = "";
        this.cur_id = 2;
        this.deb_type = "";
        this.bo_id = "";
        this.cu_id = "";
        this.su_id = "";
        this.created_at = "";
        this.deb_return_date = "";
        this.resetDebtBalance();
        this.$store.state.add_debt.isBtnLoading = false;
        this.isSubmited = false;
        //go to /debt-detail/ + debt_id window
        if (this.isPrint == "1") {
          window.location.href = "/debt-detail/" + debt_id;
        }
      }
      this.isSubmited = false;
    },
    checkRulesIsError(value, type, rules) {
      var isError = false;
      var errorMsg = "";
      if (type == "add") {
        if (this.isSubmited == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }
      for (const rule of rules) {
        if (rule(value) !== true) {
          isError = true;
          errorMsg = rule(value);
          // Stop the loop
          break;
        } else {
          isError = false;
          errorMsg = "";
        }
      }

      return {
        isError: isError,
        errorMsg: errorMsg,
      };
    },
    printStatus() {},
    checkIsEmpty(value) {
      if (value == "" || value == null) return true;
      return false;
    },
  },
};
</script>
<style>
.multiselect__tags {
  min-height: 40px;
  display: block;
  padding: 8px 40px 0 8px;
  border-radius: 5px;
  border: 1px none;

  font-size: 14px;
}
</style>
